import Axios from "../../../../api/axios/Axios";

export const createStreamThumbnailUploadUrl = (contentType) =>
  Axios.post("/api/streams/thumbnail-upload-url", {
    contentType,
  });

export const createStream = (data) => Axios.post("/api/streams/create", data);

export const getStreamsByUsername = (username) =>
  Axios.get(`/api/streams/creators/${username}`);

export const getStreamById = (streamSessionId) =>
  Axios.get(`/api/streams/${streamSessionId}/replay`);

export const getStreamSessionById = (streamSessionId) =>
  Axios.get(`/api/streams/${streamSessionId}/replay`);

export const getStreamWatchData = (streamSessionId) =>
  Axios.get(`/api/streams/${streamSessionId}/watch`);

export const getStreamBroadcastData = (streamSessionId) =>
  Axios.get(`/api/streams/${streamSessionId}/broadcast`);

export const getAllStreams = (accessType) =>
  Axios.get(`/api/streams/access/${accessType}`);

export const markStreamLive = (streamSessionId) =>
  Axios.post(`/api/streams/${streamSessionId}/start`);

export const markStreamEnded = (streamSessionId) =>
  Axios.post(`/api/streams/${streamSessionId}/end`);

export const processStreamRecording = (streamSessionId) =>
  Axios.post(`/api/streams/${streamSessionId}/process-recording`);

export const linkIvsRecordingToStream = (streamSessionId) =>
  Axios.post(`/api/streams/${streamSessionId}/link-ivs-recording`);

export const updateStreamDetails = (streamSessionId, data) =>
  Axios.put(`/api/streams/${streamSessionId}/update`, data);

export const deleteStream = (streamSessionId) =>
  Axios.delete(`/api/streams/${streamSessionId}/delete`);
